
import { selectColor } from '../libs/helpers';

export default {
  name: 'AInput',
  inheritAttrs: false,
  props: {
    rightButton: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    boxRightIcon: {
      type: String,
      default: '',
    },
    boxLeftIcon: {
      type: String,
      default: '',
    },
    boxColor: {
      type: String,
      default: '',
    },
    boxType: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconColor() {
      return selectColor(this.boxColor);
    },
  },
};
